"use strict";

var cov_2hq9dvbgaw = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\language-detection.js";
  var hash = "81074e48e5c59e8d4e7d2d25d548b32b6ea3cb91";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\language-detection.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 24
        },
        end: {
          line: 5,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 2,
          column: 60
        }
      },
      "2": {
        start: {
          line: 3,
          column: 18
        },
        end: {
          line: 3,
          column: 52
        }
      },
      "3": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 24
          },
          end: {
            line: 1,
            column: 25
          }
        },
        loc: {
          start: {
            line: 1,
            column: 36
          },
          end: {
            line: 5,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 2,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 2,
            column: 54
          }
        }, {
          start: {
            line: 2,
            column: 58
          },
          end: {
            line: 2,
            column: 60
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "81074e48e5c59e8d4e7d2d25d548b32b6ea3cb91"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHebrew = void 0;
cov_2hq9dvbgaw.s[0]++;

var isHebrew = function isHebrew(string) {
  cov_2hq9dvbgaw.f[0]++;
  var hebrewChars = (cov_2hq9dvbgaw.s[1]++, (cov_2hq9dvbgaw.b[0][0]++, string.match(/[\u0590-\u05FF]/g)) || (cov_2hq9dvbgaw.b[0][1]++, []));
  var percent = (cov_2hq9dvbgaw.s[2]++, hebrewChars.length / string.length);
  cov_2hq9dvbgaw.s[3]++;
  return percent > 0.75;
};

exports.isHebrew = isHebrew;